import React from 'react'
import PropTypes from 'prop-types'

import Dialog from 'material-ui/Dialog'
import FlatButton from 'material-ui/FlatButton'

export default class EstimateToInvoiceConfirmationDialog extends React.Component {

  static propTypes = {
    open: PropTypes.bool.isRequired,
    onActionConfirmed: PropTypes.func.isRequired,
    onCloseRequested: PropTypes.func.isRequired
  }

  handleCloseRequested = () => {
    this.props.onCloseRequested()
  }

  render() {
    if (!this.props.open) {
      return null
    }
    return (
      <Dialog open={this.props.open}
        onRequestClose={this.props.onCloseRequested}
        modal={true}
        actions={
          <div style={styles.actions}>
            <FlatButton
              label='Cancel'
              onTouchTap={this.props.onCloseRequested} />
            <FlatButton
              label='Convert'
              primary={true}
              onTouchTap={this.props.onActionConfirmed} />
          </div>
        }
        title='Convert an estimate to an invoice'
        titleStyle={{ backgroundColor: '#fafafa', padding: 12, fontSize: 18 }}
        bodyStyle={styles.dialogBody}
        contentStyle={styles.dialogContent}
        actionsContainerStyle={{ padding: 0 }}>
        <div style={styles.content}>
          Convert this estimate to a draft invoice?
        </div>
      </Dialog>
    )
  }

}

const styles = {
  dialogContent: {
    borderRadius: 4,
    // This is a hack as there is a bug in Dialog's definition to properly
    // apply the border radius.
    overflow: 'auto',
    width: 400
  },
  dialogBody: {
    display: 'flex',
    flexDirection: 'column',
    padding: 0,
    borderRadius: 4
  },
  actions: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-end',
    alignItems: 'center',
    height: 48,
    paddingRight: 16,
    backgroundColor: '#fafafa'
  },
  content: {
    marginTop: 15,
    marginLeft: 15,
    marginBottom: 48,
    fontSize: 14,
    color: '#4a4a4a'
  }
}



// WEBPACK FOOTER //
// ./src/billing/estimates/EstimateToInvoiceConfirmationDialog.js